module.exports = __webpack_public_path__ + "img/12.0b4ff8f.png";